// extracted by mini-css-extract-plugin
export default {"dash":"styles_dash__ARkWA"};